import { makeAutoObservable } from 'mobx';
import { UserData } from '@codefluegel/wowis-rest-typescript-client';

const emptyUserData: UserData | undefined = undefined;

export default class UserStore {
  private userData: UserData | undefined = emptyUserData;

  private hasBlackboard = false;

  constructor() {
    makeAutoObservable(this);
  }

  getUserData(): UserData | undefined {
    return this.userData;
  }

  setUserData(userData: UserData): void {
    this.userData = userData;
  }

  getBlackBoard(): boolean {
    return this.hasBlackboard;
  }

  setHasBlackboard(hasBlackboard: boolean): void {
    this.hasBlackboard = hasBlackboard;
  }
}
